<template>
    <div class="labelled-checkbox">
        <default-checkbox class="labelled-checkbox__checkbox"
                          :id="id"
                          :checked="checked"
                          @change="emitChange($event)"
        >

        </default-checkbox>

        <label class="labelled-checkbox__label"
               :for="id"
        >
            <slot />
        </label>
    </div>
</template>

<script>
import DefaultCheckbox from './default-checkbox';
import { uid } from '../../utils/uid';

export default {
    components: { DefaultCheckbox },
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        id: {
            type: String,
            default: () => uid('labelled-checkbox_')
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        emitChange(checked) {
            this.$emit('change', checked);
        }
    }
}
</script>

<style scoped lang="scss">
.labelled-checkbox {
    display: inline-flex;
    align-items: center;
}

.labelled-checkbox__checkbox {
    display: inline-block;
}

.labelled-checkbox__label {
    user-select: none;
    display: inline-block;
    padding-left: 1rem;
    cursor: pointer;
    line-height: 1rem;
}
</style>
